import axiosInstance from "@/lib/axios.instance";
import type { Subscription, AddTopUpResponse } from "@/types/subscription.types";

export const getSubscription = async (): Promise<Subscription> => {
  const response = await axiosInstance.get<Subscription>("/subscriptions/fetch-sub/");
  return response.data;
};

export const addTopUp = async (amount: number): Promise<AddTopUpResponse> => {
  const response = await axiosInstance.post<AddTopUpResponse>("/subscriptions/add-topup/", {
    amount,
  });
  return response.data;
};
